import {
  FormControl,
  FormLabel,
  GridItem,
  Input,
  Text
} from '@chakra-ui/react';
import { FC } from 'react';
import StepBox from 'components/onboarding/deployment/stepBox';
import SelectTokenInput from './selectTokenInput';
import { ProgramToken } from 'types';
import { useFormContext } from 'react-hook-form';
import { FormError } from 'components/onboarding/form/FormError';

type Props = {
  tokenList: ProgramToken[];
  setStakingToken: React.Dispatch<
    React.SetStateAction<ProgramToken | undefined>
  >;
};

const SelectStakingToken: FC<Props> = ({ tokenList, setStakingToken }) => {
  const {
    register,
    formState: { errors }
  } = useFormContext();
  return (
    <StepBox heading='2. Select Staking Token'>
      <GridItem colSpan={[1, 2, 3, 4]}>
        <Text color='gray.200'>
          The staking token is the token that users need to 'stake' in order to
          accure rewards. You can use the list by typing a token name, or enter
          a ERC20 token address.
        </Text>
        <Text color='gray.200' mt={5}>
          The token purchase URL is a link that users can use to aquire the
          staking token.
        </Text>
        <Text color='gray.200' mt={5}>
          <strong>Rebasing/elastic tokens are not supported</strong>: You must
          use a wrapper/buttoned contract, such as EEFI's `UnbuttonToken ERC20
          Wrapper` if you wish for users to stake an elastic token.
        </Text>
      </GridItem>

      <GridItem>
        <SelectTokenInput
          tokenList={tokenList}
          setSelectedToken={setStakingToken}
          required
        />
      </GridItem>

      <GridItem>
        <FormControl isRequired isInvalid={!!errors.getStakingTokenUrl}>
          <FormLabel>Token purchase url</FormLabel>
          <Input
            id='getStakingTokenUrl'
            type='url'
            borderColor={'gray.300'}
            placeholder='https://'
            {...register('getStakingTokenUrl')}
          />
          {!!errors.getStakingTokenUrl && (
            <FormError>{errors.getStakingTokenUrl.message}</FormError>
          )}
        </FormControl>
      </GridItem>
    </StepBox>
  );
};

export default SelectStakingToken;
